import Vue from 'vue';
import Vuex from 'vuex';
import VuexPersist from 'vuex-persist';
import Cookies from 'js-cookie';
import volatileStore from './modules/volatileStore';
import persistentStore from './modules/persistentStore';
import jwtStore from './modules/jwtStore';

Vue.use(Vuex);

const vuexLocalStorage = new VuexPersist({
  key: 'persistedVuex',
  storage: window.localStorage,
  reducer: (state) => ({
    persistentStore: state.persistentStore,
  }),
});

const vuexCookie = new VuexPersist({
  restoreState: (key) => Cookies.getJSON(key),
  saveState: (key, state) => Cookies.set(key, state, {
    expires: 365,
  }),
  modules: ['jwtStore'],
});

const store = new Vuex.Store({
  plugins: [vuexLocalStorage.plugin, vuexCookie.plugin],
  modules: {
    volatileStore,
    persistentStore,
    jwtStore,
  },
});

export default store;

export function useStore() {
  return store;
}
